(() => {
  const maxTime = 8000;
  const intervalTime = 100;
  let elapsedTime = 0;
  
  const interval = setInterval(() => {
    const subtotalEl = document.querySelector(".cart-subtotal");
    const discountWrapper = document.querySelector(".bss-b2b-discount-code-wrapper");
    const teWrapper = document.querySelector(".bss-b2b-tax-ex-wrapper");
  
    if (subtotalEl && discountWrapper) {
      subtotalEl.parentNode.insertBefore(discountWrapper, subtotalEl);
      subtotalEl.parentNode.insertBefore(teWrapper, subtotalEl);
      clearInterval(interval);
    }
  
    elapsedTime += intervalTime;
    if (elapsedTime >= maxTime) {
      clearInterval(interval);
    }
  }, intervalTime);
})()